import axios from 'axios';
import { authHeader } from './authHeader'; 

const API_URL = process.env.REACT_APP_API_URL; 

const getEmailTemplates = (params) => {
    return axios.get(`${API_URL}/api/email`, {
        params: params,
        headers: authHeader(),
    });
};

const getEmailTemplateById = async (id) => {
    const response = await axios.get(`${API_URL}/api/email/${id}`, {
        headers: authHeader(),
    });
    return response.data;
};

const addEmailTemplate = async (formData) => {
    const response = await axios.post(`${API_URL}/api/email`, formData, {
        headers: authHeader(),
    });
    return response.data;
};

const updateEmailTemplate = async (id, formData) => {
    const response = await axios.put(`${API_URL}/api/email/update/${id}`, formData, {
        headers: authHeader(),
    });
    return response.data;
};

const deleteEmailTemplate = async (id) => {
    const response = await axios.delete(`${API_URL}/api/email${id}`, {
        headers: authHeader(),
    });
    return response.data;
};



const EmailAPI = {
    getEmailTemplates,
    getEmailTemplateById,
    addEmailTemplate,
    updateEmailTemplate,
    deleteEmailTemplate
};

export default EmailAPI;
